import { useTcpaQuestionCustomContext } from '../context'

import TemplateBuilderTab from './TemplateBuilder'
import { HOOKS } from './TemplateBuilder/Builder/templates'

export function TcpaQuestionCustomProvider() {
  const { tcpaquestioncustom, onChange, disabled } = useTcpaQuestionCustomContext()
  const useTemplateState = HOOKS[tcpaquestioncustom.templateType || 'button-and-dropdown']
  useTemplateState({ tcpaData: tcpaquestioncustom, onChange, disabled })
  return null
}

export function TemplateBuilderContent() {
  const { tcpaquestioncustom, onChange, disabled } = useTcpaQuestionCustomContext()
  return <TemplateBuilderTab data={tcpaquestioncustom} onChange={onChange} disabled={disabled} />
}
